<button type="button" class="scv2-rate-option" [class.scv2-selected]="selected" (click)="selectRate.emit(id)">
  <app-carrier-mark-v2 [carrierId]="carrier" [size]="32"></app-carrier-mark-v2>
  <div class="scv2-rate-main">
    <div class="scv2-rate-service">
      {{ service }}
      <span *ngIf="suggested" class="scv2-badge scv2-badge-green">Suggested</span>
    </div>
    <div class="scv2-rate-eta"><i class="pi pi-clock"></i> {{ eta }}</div>
  </div>
  <div class="scv2-rate-price">${{ price.toFixed(2) }}</div>
  <div class="scv2-rate-radio" [class.scv2-selected]="selected">
    <div *ngIf="selected" class="scv2-rate-radio-dot"></div>
  </div>
</button>
